export enum DeterminedPlacementResponsibility {
  Client = 'Client',
  Pilot = 'Pilot',
  Surveyor = 'Surveyor',
  PilotWithPpls = 'Pilot with PPLS',
}
